import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  makeStyles,
} from '@material-ui/core';

import Button from '~/components/Button';
import { DeleteFourIcon } from '~/icons';

export const PAGE_NAME = 'DC_removeApp';

const useStyles = makeStyles({
  removeButtonIcon: { marginRight: 8 },
  paperClassName: { width: 416 },
});

function RemoveAppButton({ appName, onAppRemove }) {
  const styles = useStyles();
  const [isConfirmationDialogOpened, setConfirmationDialogOpened] = useState(false);
  const closeConfirmationDialog = () => setConfirmationDialogOpened(false);

  return (
    <>
      <Button
        color="primary"
        data-testid={`${PAGE_NAME}_button`}
        onClick={() => setConfirmationDialogOpened(true)}
      >
        <DeleteFourIcon className={styles.removeButtonIcon} />
        REMOVE APP
      </Button>
      <Dialog
        open={isConfirmationDialogOpened}
        onClose={closeConfirmationDialog}
        PaperProps={{ elevation: 1, className: styles.paperClassName }}
      >
        <DialogTitle data-testid={`${PAGE_NAME}_title`}>Remove {appName}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            App and all related information will be removed immediately. App can be added again from
            AppStore.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            data-testid={`${PAGE_NAME}_cancel`}
            onClick={closeConfirmationDialog}
          >
            Cancel
          </Button>
          <Button
            data-testid={`${PAGE_NAME}_confirm`}
            // this fn comes from parent window through an iframe.
            // It's important to call it without native event as it's not possible
            // to pass it through the iframe, because it contains circular dependencies
            onClick={() => onAppRemove()}
            variation="primary"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RemoveAppButton;
